import { ReactElement } from 'react';
import { Box } from '@twilio-paste/core/box';
import { Breadcrumb, BreadcrumbItem } from '@twilio-paste/core/breadcrumb';
import { SkeletonLoader } from '@twilio-paste/core/skeleton-loader';

import { types } from './definitions';
import styles from './pageBreadcrumb.module.css';
import { dataTestIds } from '@twiliointernal/e2-commons-shared-definitions';

const PageBreadcrumb = ({
  isLoading,
  items,
}: types.PageBreadcrumbProps): ReactElement => {
  if (isLoading) {
    return (
      <Box marginBottom="space90" data-testid={dataTestIds.breadcrumb.loader}>
        <SkeletonLoader height="21px" maxWidth="250px" />
      </Box>
    );
  }

  return (
    <Box as="div" className={styles.pageBreadCrumbContainer}>
      <Breadcrumb data-testid={dataTestIds.breadcrumb.default}>
        {items.map((item, index) => {
          if (item.href) {
            return (
              <BreadcrumbItem key={`${index}-${item.name}`} href={item.href}>
                {item.name}
              </BreadcrumbItem>
            );
          }

          return (
            <BreadcrumbItem key={`${index}-${item.name}`}>
              {item.name}
            </BreadcrumbItem>
          );
        })}
      </Breadcrumb>
    </Box>
  );
};

export default PageBreadcrumb;
